// import React from "react";
// import Login from "./components/Login";
// import { BrowserRouter, Route, Routes } from "react-router-dom";
// import SgbDetails from "../src/components/SgbDetails";
// import RazorPay from "./components/RazorPay";
// import Thankyou from "./components/Thankyou";

// const App = () => {
//   return (
//     <BrowserRouter basename="/sgb">
//       {/* <BrowserRouter> */}
//       <Routes>
//         <Route path="/" element={<Login />}></Route>
//         <Route path="/sgbdetails" element={<SgbDetails />}></Route>
//         <Route path="/razorpay" element={<RazorPay />}></Route>
//         <Route path="/thankyou" element={<Thankyou />}></Route>
//       </Routes>
//     </BrowserRouter>
//   );
// };

// export default App;

import React from "react";
import Login from "./components/Login";
import { Route, Routes, HashRouter } from "react-router-dom";
import SgbDetails from "../src/components/SgbDetails";
import RazorPay from "./components/RazorPay";

const App = () => {
  return (
    <HashRouter>
      <Routes>
        <Route path="" element={<Login />} />
        <Route path="sgbdetails" element={<SgbDetails />} />
        <Route path="razorpay" element={<RazorPay />} />
        <Route path="*" element={<Login />} />
      </Routes>
    </HashRouter>
  );
};

export default App;
